import { render, staticRenderFns } from "./UploadAttachmentsModal.vue?vue&type=template&id=25aab2f2&scoped=true"
import script from "./UploadAttachmentsModal.vue?vue&type=script&lang=js"
export * from "./UploadAttachmentsModal.vue?vue&type=script&lang=js"
import style0 from "./UploadAttachmentsModal.vue?vue&type=style&index=0&id=25aab2f2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25aab2f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2718431902/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25aab2f2')) {
      api.createRecord('25aab2f2', component.options)
    } else {
      api.reload('25aab2f2', component.options)
    }
    module.hot.accept("./UploadAttachmentsModal.vue?vue&type=template&id=25aab2f2&scoped=true", function () {
      api.rerender('25aab2f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/UploadAttachmentsModal.vue"
export default component.exports